import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { LocaleService } from '../core/services/locale/locale.service';
import * as sbLangData from '../lazy-modules/locale/translations/en-US/sb.lang';
import { SharedModule } from '../shared/shared.module';
import { BuildYourBetHomeComponent } from './components/buildYourBetHome/build-your-bet-home.component';
import { BuildYourBetTabComponent } from './components/buildYourBetTab/build-your-bet-tab.component';
import { InsightsMainComponent } from './components/insightsTab/insights-main.component';
import { MatchResultsSportTabComponent } from './components/matchResultsSportTab/match-results-sport-tab.component';
import { OutrightsSportTabComponent } from './components/outrightsSportTab/outrights-sport-tab.component';
import { PrivateMarketsTabComponent } from './components/privateMarketsTab/private-markets-tab.component';
import { PrivateMarketsTermsAndConditionsComponent } from './components/privateMarketsTab/private-markets-terms-and-conditions.component';

@NgModule({
    declarations: [
        OutrightsSportTabComponent,
        BuildYourBetTabComponent,
        PrivateMarketsTabComponent,
        PrivateMarketsTermsAndConditionsComponent,
        MatchResultsSportTabComponent,
        BuildYourBetHomeComponent,
        InsightsMainComponent,
    ],
    exports: [
        BuildYourBetTabComponent,
        PrivateMarketsTabComponent,
        PrivateMarketsTermsAndConditionsComponent,
        MatchResultsSportTabComponent,
        BuildYourBetHomeComponent,
        OutrightsSportTabComponent,
        InsightsMainComponent,
    ],
    schemas: [NO_ERRORS_SCHEMA],
    imports: [FormsModule, SharedModule],
    providers: [DatePipe, provideHttpClient(withInterceptorsFromDi())],
})
export class SbModule {
    constructor(private localeService: LocaleService) {
        this.localeService.setLangData(sbLangData);
    }
}
